import { Grid, Avatar } from '@mui/material';
import { IJobCandidateInteraction } from 'wisestep-api';
import { SearchBarNew, WsMoreOptionButton, WsTypography, WsTypoVariants } from 'wisestep-base';

import { handleCandidateDownload } from '../../../../features/dataDownload/helper/PayloadHelper';
import AI_Image from '../../../../images/AI.svg';
import { success, warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { FiltersTagList } from '../../components/filterTagList';
import { FiltersTagProp } from '../../components/filterTagList/FiltersTagList';

interface AISuggestionHeaderProps {
  query: IJobCandidateInteraction;
  filterTags: FiltersTagProp[];
  onTagRemoval: (id: string) => void;
}

const AISuggestionHeader = ({ query, filterTags, onTagRemoval }: AISuggestionHeaderProps) => {
  const setNotification = useNotificationStore((state) => state.setNotification);

  const handleDownload = async () => {
    const downloadStatus = await handleCandidateDownload('smartSource', query);
    downloadStatus == 'success'
      ? setNotification(success('Downloaded candidates'))
      : setNotification(warning('Something went wrong, Please try again.'));
  };

  const moreOptionHandlers: Record<string, () => void> = {
    'Export Candidates': handleDownload,
  };

  const onMoreOptionClick = (option: string) => {
    const handler = moreOptionHandlers[option];
    if (handler) {
      handler();
    } else {
      console.warn(`No handler found for option: ${option}`);
    }
  };

  return (
    <Grid display="flex" direction="column" rowGap={2}>
      <Grid xs={12} container alignItems="center" gap={1}>
        <Avatar src={AI_Image} variant="square" sx={{ width: 30, height: 30 }} />
        <WsTypography variant={WsTypoVariants.TITLE} bold>
          AI Suggestions
        </WsTypography>
      </Grid>
      <Grid xs={12} display="flex" alignItems="center" justifyContent="space-between">
        <Grid item xs={4}>
          <SearchBarNew name="searchText" type="submit" placeholder="Search by name" />
        </Grid>
        <Grid item>
          <WsMoreOptionButton
            items={Object.keys(moreOptionHandlers)}
            onItemClick={(item) => onMoreOptionClick(item)}
          />
        </Grid>
      </Grid>
      <Grid xs={12}>
        <FiltersTagList filterTags={filterTags} onClick={onTagRemoval} />
      </Grid>
    </Grid>
  );
};

export default AISuggestionHeader;
